<template>
  <div>
    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.leave_area }}
      </h2>
      <div class='mb-10' v-for='(room, index) in rooms' :key='index'>
        <h3 class='calculate-price__form-subtitle'>
          {{ facilityTypes && facilityTypes[room] && facilityTypes[room]['value'] }}
          <span v-if="room == 'other'">{{ locales && locales.properties && locales.properties.rooms }}</span>
        </h3>
        <input
          type='hidden'
          :name='`leaveArea[` + room + `][name_nl]`'
          :value="
              (facilityTypes[room] && facilityTypes[room]['value_lang']['nl']) +
              (room == 'other'
                ? locales && locales.properties && locales.properties.rooms
                : '')
            "
        />
        <input
          type='hidden'
          :name='`leaveArea[` + room + `][name_en]`'
          :value="
              (facilityTypes[room] && facilityTypes[room]['value_lang']['en']) +
              (room == 'other'
                ? locales && locales.properties && locales.properties.rooms
                : '')
            "
        />
        <div class='grid grid-cols-1 lg:grid-cols-3 gap-5 mb-5'>
          <div>
            <theme-numeric
              v-model='leaveArea[room].width'
              valid-scope='modal-form'
              :name='`leaveArea[` + room + `][width]`'
              label=''
              @input="calculateSurface(leaveArea, room, 'leaveArea')">
            </theme-numeric>
          </div>
          <div>
            <theme-numeric
              v-model='leaveArea[room].length'
              valid-scope='modal-form'
              :name='`leaveArea[` + room + `][length]`'
              label=''
              @input="calculateSurface(leaveArea, room, 'leaveArea')">
            </theme-numeric>
          </div>
          <div>
            <theme-numeric
              v-model='leaveArea[room].surface'
              valid-scope='modal-form'
              :name='`leaveArea[` + room + `][surface]`'
              label=''
              @input='countLeaveAreaPoints(leaveArea)'
              :IsExtraInfo='true'
            >
              <template slot='extra-info'> m<sup>2</sup></template>
            </theme-numeric>
          </div>
        </div>
      </div>
      <div class='mb-10'>
        <input type='hidden' name='leaveArea[include_shower]' value='0'/>
        <theme-checkboxes
          id='includeShower'
          @input='countLeaveAreaPoints(leaveArea)'
          label=''
          :is-single-checkbox='true'
          name='leaveArea[include_shower]'
          v-model='leaveArea.include_shower'
          :options="{ '1': `${locales && locales.properties && locales.properties.toilet_in_shower_or_bathroom} ${leaveArea.include_shower == 1 ? '-1' : ''}` }">
        </theme-checkboxes>
        <template v-if='leaveArea.include_shower == 1'>
          <input type='hidden' name='leaveArea[include_shower]' value='1'/>
        </template>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='leaveArea.total'
            valid-scope='modal-form'
            name='leaveArea[total]'
            :label='locales && locales.properties && locales.properties.leave_area_points_total'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.other_spaces }}
      </h2>
      <div class='mb-10' v-for='(room, index) in otherRooms' :key='index'>
        <h3 class='calculate-price__form-subtitle'>
          <span v-if="room == 'other'">{{ locales && locales.properties && locales.properties.other_spaces }}</span>
          <span v-else>{{ facilityTypes && facilityTypes[room] && facilityTypes[room]['value'] }}</span>
        </h3>
        <input
          type='hidden'
          :name='`otherSpaces[` + room + `][name_nl]`'
          :value="
              (facilityTypes[room] && facilityTypes[room]['value_lang']['nl']) +
              (room == 'other'
                ? locales && locales.properties && locales.properties.rooms
                : '')
            "
        />
        <input
          type='hidden'
          :name='`otherSpaces[` + room + `][name_en]`'
          :value="
              (facilityTypes[room] && facilityTypes[room]['value_lang']['en']) +
              (room == 'other'
                ? locales && locales.properties && locales.properties.rooms
                : '')
            "
        />
        <div class='grid grid-cols-1 lg:grid-cols-3 gap-5 mb-5'>
          <div>
            <theme-numeric
              v-model='otherSpaces[room].width'
              valid-scope='modal-form'
              :name='`otherSpaces[` + room + `][width]`'
              label=''
              @input="calculateSurface(otherSpaces, room, 'otherSpaces')">
            </theme-numeric>
          </div>
          <div>
            <theme-numeric
              v-model='otherSpaces[room].length'
              valid-scope='modal-form'
              :name='`otherSpaces[` + room + `][length]`'
              label=''
              @input="calculateSurface(otherSpaces, room, 'otherSpaces')">
            </theme-numeric>
          </div>
          <div>
            <theme-numeric
              v-model='otherSpaces[room].surface'
              valid-scope='modal-form'
              :name='`otherSpaces[` + room + `][surface]`'
              label=''
              @input='countOtherSpacesPoints(otherSpaces)'
              :IsExtraInfo='true'
            >
              <template slot='extra-info'> m<sup>2</sup></template>
            </theme-numeric>
          </div>
        </div>
      </div>
      <div class='mb-10'>
        <input
          type='hidden'
          name='otherSpaces[attic_no_staircase]'
          value='0'
        />
        <theme-checkboxes
          id='attic_no_staircase'
          @input='countOtherSpacesPoints(otherSpaces)'
          label=''
          :is-single-checkbox='true'
          name='otherSpaces[attic_no_staircase]'
          v-model='otherSpaces.attic_no_staircase'
          :options="{ '1': `${locales && locales.properties && locales.properties.attic_no_staircase} ${otherSpaces.attic_no_staircase == 1 ? '-5' : ''}` }">
        </theme-checkboxes>
        <template v-if='otherSpaces.attic_no_staircase == 1'>
          <input type='hidden' name='otherSpaces[attic_no_staircase]' value='1'/>
        </template>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='otherSpaces.total'
            valid-scope='modal-form'
            name='otherSpaces[total]'
            :label='locales && locales.properties && locales.properties.other_spaces_points_total'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.heating }}
        ({{ locales && locales.properties && locales.properties.central_heating }})
      </h2>
      <div class='mb-10'>
        <theme-radios
          :columnDirection='true'
          @input='countHeatingPoints'
          label=''
          v-model='heatingTypeClone'
          name='heating[type]'
          :extra-styling-is-enabled='true'
          class='form__item--full-width'
          :options="{
              '0':
                locales &&
                locales.properties &&
                locales.properties.separate_heater,
              '1':
                locales &&
                locales.properties &&
                locales.properties.individual_boiler,
              '2':
                locales &&
                locales.properties &&
                locales.properties.collective_heating,
            }">
        </theme-radios>
      </div>
      <div v-if='heatingTypeClone && heatingTypeClone != 0' class='grid grid-cols-1 lg:grid-cols-3 items-end gap-5 mb-10'>
        <div>
          <theme-numeric
            v-model='heating.heated_rooms'
            valid-scope='modal-form'
            name='heating[heated_rooms]'
            :label="`${locales && locales.properties && locales.properties.number_of_heated_rooms} ${heating.heated_rooms && heating.heated_rooms_points || ''}`"
            @input='countHeatingPoints'
            :precision='0'>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model='heating.other_rooms_with_heating'
            valid-scope='modal-form'
            name='heating[other_rooms_with_heating]'
            :label="`${locales && locales.properties && locales.properties.number_of_other_rooms_with_heating} ${heating.other_rooms_with_heating && heating.other_rooms_with_heating_points || ''}`"
            @input='countHeatingPoints'
            :precision='0'>
          </theme-numeric>
        </div>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='heating.total'
            valid-scope='modal-form'
            name='heating[total]'
            :label='locales && locales.properties && locales.properties.total_heating'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.energy_performance }}
      </h2>
      <div class='mb-10'>
        <h3 class='calculate-price__form-subtitle'>
          {{ locales && locales.properties && locales.properties.property_type }}
        </h3>
        <theme-radios
          :columnDirection='true'
          v-model='energy.property_type'
          name='energy[property_type]'
          :options="{
              '1':
                locales &&
                locales.properties &&
                locales.properties.single_family_home,
              '2':
                locales &&
                locales.properties &&
                locales.properties.multi_family_home,
            }"
          @input='countEnergyPoints'>
        </theme-radios>
      </div>
      <div v-if='energy.energy_performance_fee != 1' class='mb-10'>
        <h3 class='calculate-price__form-subtitle'>
          {{ locales && locales.properties && locales.properties.energy_label }}
          <strong v-if="energy.energy_label && energyLabels[energy.energy_label] && energyLabels[energy.energy_label]['slug'] != 'no_label_or_index'">
            {{ energy.energy_points || '' }}
          </strong>
        </h3>
        <div class='mb-10'>
          <theme-radios
            v-model='energy.energy_label'
            name='energy[energy_label]'
            :options='energyLabelsOptions'
            :sort='true'
            sort-by='custom'
            :custom-order='energyLabelsCustomOrder'
            @input='countEnergyPoints'>
          </theme-radios>
        </div>
        <div v-if="energy.energy_label && energyLabels[energy.energy_label] && energyLabels[energy.energy_label]['slug'] == 'no_label_or_index'" class='grid grid-cols-1 lg:grid-cols-12'>
          <div class='col-span-4'>
            <theme-input
              @input='countEnergyPoints'
              :label="`${locales &&locales.properties && locales.properties.construction_year} ${energy.building_construction_year && energy.energy_points || ''}`"
              v-model='energy.building_construction_year'
              name='energy[building_construction_year]'>
            </theme-input>
          </div>
        </div>
      </div>
      <div class='mb-5'>
        <input type='hidden' name='energy[energy_performance_fee]' value='0'/>
        <theme-checkboxes
          id='energy_performance_fee'
          @input='countEnergyPoints'
          label=''
          :is-single-checkbox='true'
          name='energy[energy_performance_fee]'
          v-model='energy.energy_performance_fee'
          :options="{ '1': `${locales && locales.properties && locales.properties.energy_performance_fee} ${energy.energy_performance_fee == 1 ? energy.energy_points : ''}` }">
        </theme-checkboxes>
        <template v-if='energy.energy_performance_fee == 1'>
          <input type='hidden' name='energy[energy_performance_fee]' value='1'/>
        </template>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='energy.total'
            valid-scope='modal-form'
            name='energy[total]'
            :label='locales && locales.properties && locales.properties.total_energy'
            :precision='0'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.kitchen }}
      </h2>
      <div class='grid grid-cols-1 lg:grid-cols-3 gap-5 mb-10'>
        <div>
          <h3 class='calculate-price__form-subtitle'>
            {{ locales && locales.properties && locales.properties.worktop_length }}
            <strong v-if='kitchen.worktop_length.value'>{{ kitchen.worktop_length.total || '' }}</strong>
          </h3>
          <theme-radios
            :columnDirection='true'
            v-model='kitchen.worktop_length.value'
            name='kitchen[worktop_length]'
            :options="{
              '1':
                locales &&
                locales.properties &&
                locales.properties.less_than_1_meter,
              '2':
                locales &&
                locales.properties &&
                locales.properties['1_2_meters'],
              '3':
                locales &&
                locales.properties &&
                locales.properties.more_than_2_meters,
            }"
            @input='countKitchenPoints'>
          </theme-radios>
        </div>
        <div>
          <h3 class='calculate-price__form-subtitle'>
            {{ locales && locales.properties && locales.properties.cooker }}
            <strong v-if='kitchen.cooker.value'>{{ kitchen.cooker.total || '' }}</strong>
          </h3>
          <theme-radios
            :columnDirection='true'
            v-model='kitchen.cooker.value'
            name='kitchen[cooker]'
            :options="{
              '1':
                locales &&
                locales.properties &&
                locales.properties.built_in_hob,
              '2':
                locales &&
                locales.properties &&
                locales.properties.built_in_hob_luxury,
              '3':
                locales &&
                locales.properties &&
                locales.properties.built_in_ceramic_hob,
            }"
            @input='countKitchenPoints'>
          </theme-radios>
        </div>
        <div>
          <h3 class='calculate-price__form-subtitle'>
            {{ locales && locales.properties && locales.properties.oven }}
            <strong v-if='kitchen.oven.value'>{{ kitchen.oven.total || '' }}</strong>
          </h3>
          <theme-radios
            :columnDirection='true'
            v-model='kitchen.oven.value'
            name='kitchen[oven]'
            :options="{
              '1':
                locales &&
                locales.properties &&
                locales.properties.built_in_oven,
              '2':
                locales &&
                locales.properties &&
                locales.properties.built_in_oven_including_hob,
            }"
            @input='countKitchenPoints'>
          </theme-radios>
        </div>
      </div>
      <div class='mb-10'>
        <div class='grid grid-cols-1 lg:grid-cols-5 gap-5'>
          <div>
            <input type='hidden' name='kitchen[built_in_microwave]' value='0'/>
            <theme-checkboxes
              id='built_in_microwave'
              @input='countKitchenPoints'
              label=''
              :is-single-checkbox='true'
              name='kitchen[built_in_microwave]'
              v-model='kitchen.built_in_microwave.value'
              :options="{ '1': `${locales && locales.properties && locales.properties.built_in_microwave} ${kitchen.built_in_microwave.value == 1 ? kitchen.built_in_microwave.total : ''}` }">
            </theme-checkboxes>
          </div>
          <div>
            <input type='hidden' name='kitchen[built_in_extractor_hood]' value='0'/>
            <theme-checkboxes
              id='built_in_extractor_hood'
              @input='countKitchenPoints'
              label=''
              :is-single-checkbox='true'
              name='kitchen[built_in_extractor_hood]'
              v-model='kitchen.built_in_extractor_hood.value'
              :options="{ '1': `${locales && locales.properties && locales.properties.built_in_extractor_hood} ${kitchen.built_in_extractor_hood.value == 1 ? kitchen.built_in_extractor_hood.total : ''}` }">
            </theme-checkboxes>
          </div>
          <div>
            <input type='hidden' name='kitchen[built_in_fridge]' value='0'/>
            <theme-checkboxes
              id='built_in_fridge'
              @input='countKitchenPoints'
              label=''
              :is-single-checkbox='true'
              name='kitchen[built_in_fridge]'
              v-model='kitchen.built_in_fridge.value'
              :options="{ '1': `${locales && locales.properties && locales.properties.built_in_fridge} ${kitchen.built_in_fridge.value == 1 ? kitchen.built_in_fridge.total : ''}` }">
            </theme-checkboxes>
          </div>
          <div>
            <input type='hidden' name='kitchen[built_in_freezer]' value='0'/>
            <theme-checkboxes
              id='built_in_freezer'
              @input='countKitchenPoints'
              label=''
              :is-single-checkbox='true'
              name='kitchen[built_in_freezer]'
              v-model='kitchen.built_in_freezer.value'
              :options="{ '1': `${locales && locales.properties && locales.properties.built_in_freezer} ${kitchen.built_in_freezer.value == 1 ? kitchen.built_in_freezer.total : ''}` }">
            </theme-checkboxes>
          </div>
          <div>
            <input type='hidden' name='kitchen[built_in_freezer_fridge_combination]' value='0'/>
            <theme-checkboxes
              id='built_in_freezer_fridge_combination'
              @input='countKitchenPoints'
              label=''
              :is-single-checkbox='true'
              name='kitchen[built_in_freezer_fridge_combination]'
              v-model='kitchen.built_in_freezer_fridge_combination.value'
              :options="{ '1': `${locales && locales.properties && locales.properties.built_in_freezer_fridge_combination} ${kitchen.built_in_freezer_fridge_combination.value == 1 ? kitchen.built_in_freezer_fridge_combination.total : ''}` }">
            </theme-checkboxes>
          </div>
          <div>
            <input type='hidden' name='kitchen[built_in_dishwasher]' value='0'/>
            <theme-checkboxes
              id='built_in_dishwasher'
              @input='countKitchenPoints'
              label=''
              :is-single-checkbox='true'
              name='kitchen[built_in_dishwasher]'
              v-model='kitchen.built_in_dishwasher.value'
              :options="{ '1': `${locales && locales.properties && locales.properties.built_in_dishwasher} ${kitchen.built_in_dishwasher.value == 1 ? kitchen.built_in_dishwasher.total : ''}` }">
            </theme-checkboxes>
          </div>
          <div>
            <input type='hidden' name='kitchen[double_sink]' value='0'/>
            <theme-checkboxes
              id='double_sink'
              @input='countKitchenPoints'
              label=''
              :is-single-checkbox='true'
              name='kitchen[double_sink]'
              v-model='kitchen.double_sink.value'
              :options="{ '1': `${locales && locales.properties && locales.properties.double_sink} ${kitchen.double_sink.value == 1 ? '' : 'kitchen.double_sink.total'}` }">
            </theme-checkboxes>
          </div>
        </div>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-4 gap-5 mb-10 items-end'>
        <div>
          <theme-numeric
            v-model='kitchen.luxury_mixer_tap.value'
            valid-scope='modal-form'
            name='kitchen[luxury_mixer_tap]'
            :label="`${locales && locales.properties && locales.properties.luxury_mixer_tap} ${kitchen.luxury_mixer_tap.value ? kitchen.luxury_mixer_tap.total : ''}`"
            :precision='0'
            @input='countKitchenPoints'>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model='kitchen.thermostatic_water_mixer.value'
            valid-scope='modal-form'
            name='kitchen[thermostatic_water_mixer]'
            :label="`${locales && locales.properties && locales.properties.thermostatic_water_mixer} ${kitchen.thermostatic_water_mixer.value ? kitchen.thermostatic_water_mixer.total : ''}`"
            :precision='0'
            @input='countKitchenPoints'>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model='kitchen.extra_single_cupboard.value'
            valid-scope='modal-form'
            name='kitchen[extra_single_cupboard]'
            :label="`${locales && locales.properties && locales.properties.extra_single_cupboard} ${kitchen.extra_single_cupboard.value ? kitchen.extra_single_cupboard.total : ''}`"
            :precision='0'
            @input='countKitchenPoints'>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model='kitchen.extra_double_closet.value'
            valid-scope='modal-form'
            name='kitchen[extra_double_closet]'
            :label="`${locales && locales.properties && locales.properties.extra_double_closet} ${kitchen.extra_double_closet.value ? kitchen.extra_double_closet.total : ''}`"
            :precision='0'
            @input='countKitchenPoints'>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model='kitchen.extra_wall_tiling.value'
            valid-scope='modal-form'
            name='kitchen[extra_wall_tiling]'
            :label="`${locales && locales.properties && locales.properties.extra_wall_tiling} ${kitchen.extra_wall_tiling.value ? kitchen.extra_wall_tiling.total : ''}`"
            :precision='2'
            @input='countKitchenPoints'>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model='kitchen.floor_tiles.value'
            valid-scope='modal-form'
            name='kitchen[floor_tiles]'
            :label="`${locales && locales.properties && locales.properties.floor_tiles} ${kitchen.floor_tiles.value ? kitchen.floor_tiles.total : ''}`"
            :precision='2'
            @input='countKitchenPoints'>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model='kitchen.overall_luxury_version.value'
            valid-scope='modal-form'
            name='kitchen[overall_luxury_version]'
            :label="`${locales && locales.properties && locales.properties.overall_luxury_version} ${kitchen.overall_luxury_version.value ? kitchen.overall_luxury_version.total : ''}`"
            :precision='0'
            @input='countKitchenPoints'>
          </theme-numeric>
        </div>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='kitchen.total'
            valid-scope='modal-form'
            name='kitchen[total]'
            :label='locales && locales.properties && locales.properties.total_kitchen'
            :precision='2'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.sanitary }}
      </h2>
      <div class='grid grid-cols-1 lg:grid-cols-4 gap-5 mb-10 items-end'>
        <div>
          <theme-input
            @input='countSanitaryPoints'
            :label="`${locales && locales.properties && locales.properties.number_of_toilets} ${sanitary.number_of_toilets.value && sanitary.number_of_toilets.total || ''}`"
            v-model='sanitary.number_of_toilets.value'
            name='sanitary[number_of_toilets]'>
          </theme-input>
        </div>
        <div>
          <theme-input
            @input='countSanitaryPoints'
            :label="`${locales && locales.properties && locales.properties.number_of_washbasins} ${sanitary.number_of_washbasins.value && sanitary.number_of_washbasins.total || ''}`"
            v-model='sanitary.number_of_washbasins.value'
            name='sanitary[number_of_washbasins]'>
          </theme-input>
        </div>
      </div>
      <div class='mb-10'>
        <h3 class='calculate-price__form-subtitle'>
          {{ locales && locales.properties && locales.properties.sanitary }}
          <strong v-if='sanitary.shower_bath.value'>{{ sanitary.shower_bath.total || '' }}</strong>
        </h3>
        <theme-radios
          @input='countSanitaryPoints'
          label=''
          name='sanitary[shower_bath]'
          v-model='sanitary.shower_bath.value'
          :options="{
              '0':
                locales &&
                locales.properties &&
                locales.properties.no_shower_or_bath,
              '1':
                locales &&
                locales.properties &&
                locales.properties.shower_available,
              '2':
                locales &&
                locales.properties &&
                locales.properties.bath_available,
              '3':
                locales &&
                locales.properties &&
                locales.properties.separate_bath_and_shower_in_one_room,
            }">
        </theme-radios>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-4 gap-5 mb-10'>
        <div>
          <input type='hidden' name='sanitary[cupboard_with_built_in_washbasin]' value='0'/>
          <theme-checkboxes
            id='cupboard_with_built_in_washbasin'
            @input='countSanitaryPoints'
            label=''
            :is-single-checkbox='true'
            name='sanitary[cupboard_with_built_in_washbasin]'
            v-model='sanitary.cupboard_with_built_in_washbasin.value'
            :options="{ '1': `${locales && locales.properties && locales.properties.cupboard_with_built_in_washbasin} ${sanitary.cupboard_with_built_in_washbasin.value == 1 ? sanitary.cupboard_with_built_in_washbasin.total : ''}` }">
          </theme-checkboxes>
        </div>
        <div>
          <input
            type='hidden'
            name='sanitary[toilet_cabinet_with_built_in_lighting]'
            value='0'
          />
          <theme-checkboxes
            id='toilet_cabinet_with_built_in_lighting'
            @input='countSanitaryPoints'
            label=''
            :is-single-checkbox='true'
            name='sanitary[toilet_cabinet_with_built_in_lighting]'
            v-model='sanitary.toilet_cabinet_with_built_in_lighting.value'
            :options="{ '1': `${locales && locales.properties && locales.properties.toilet_cabinet_with_built_in_lighting} ${sanitary.toilet_cabinet_with_built_in_lighting.value == 1 ? sanitary.toilet_cabinet_with_built_in_lighting.total : ''}` }">
          </theme-checkboxes>
        </div>
        <div>
          <input type='hidden' name='sanitary[extra_for_a_bubble_bath]' value='0'/>
          <theme-checkboxes
            id='extra_for_a_bubble_bath'
            @input='countSanitaryPoints'
            label=''
            :is-single-checkbox='true'
            name='sanitary[extra_for_a_bubble_bath]'
            v-model='sanitary.extra_for_a_bubble_bath.value'
            :options="{ '1': `${locales && locales.properties && locales.properties.extra_for_a_bubble_bath} ${sanitary.extra_for_a_bubble_bath.value == 1 ? sanitary.extra_for_a_bubble_bath.total : ''}` }">
          </theme-checkboxes>
        </div>
        <div>
          <input type='hidden' name='sanitary[sliding_or_folding_wall_with_aluminium_frame]' value='0'/>
          <theme-checkboxes
            id='sliding_or_folding_wall_with_aluminium_frame'
            @input='countSanitaryPoints'
            label=''
            :is-single-checkbox='true'
            name='sanitary[sliding_or_folding_wall_with_aluminium_frame]'
            v-model='sanitary.sliding_or_folding_wall_with_aluminium_frame.value'
            :options="{ '1': `${locales && locales.properties && locales.properties.sliding_or_folding_wall_with_aluminium_frame} ${sanitary.sliding_or_folding_wall_with_aluminium_frame.value == 1 ? sanitary.sliding_or_folding_wall_with_aluminium_frame.total : ''}` }">
          </theme-checkboxes>
        </div>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-4 gap-5 mb-10 items-end'>
        <div>
          <theme-numeric
            v-model='sanitary.luxury_mixer_tap.value'
            valid-scope='modal-form'
            name='sanitary[luxury_mixer_tap]'
            :label="`${locales && locales.properties && locales.properties.luxury_mixer_tap} ${sanitary.luxury_mixer_tap.value ? sanitary.luxury_mixer_tap.total : ''}`"
            :precision='0'
            @input='countSanitaryPoints'>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model='sanitary.thermostatic_water_mixer.value'
            valid-scope='modal-form'
            name='sanitary[thermostatic_water_mixer]'
            :label="`${locales && locales.properties && locales.properties.thermostatic_water_mixer} ${sanitary.thermostatic_water_mixer.value ? sanitary.thermostatic_water_mixer.total : ''}`"
            :precision='0'
            @input='countSanitaryPoints'>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model='sanitary.extra_wall_tiling.value'
            valid-scope='modal-form'
            name='sanitary[extra_wall_tiling]'
            :label="`${locales && locales.properties && locales.properties.extra_wall_tiling} ${sanitary.extra_wall_tiling.value ? sanitary.extra_wall_tiling.total : ''}`"
            :precision='2'
            @input='countSanitaryPoints'>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model='sanitary.overall_luxury_version.value'
            valid-scope='modal-form'
            name='sanitary[overall_luxury_version]'
            :label="`${locales && locales.properties && locales.properties.overall_luxury_version} ${sanitary.overall_luxury_version.value ? sanitary.overall_luxury_version.total : ''}`"
            :precision='0'
            @input='countSanitaryPoints'>
          </theme-numeric>
        </div>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='sanitary.total'
            valid-scope='modal-form'
            name='sanitary[total]'
            :label='locales && locales.properties && locales.properties.total_sanitary'
            :precision='2'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.housing_for_disabled }}
      </h2>
      <div class='grid grid-cols-1 lg:grid-cols-4 gap-5 mb-10 items-end'>
        <div>
          <theme-numeric
            v-model='disabled.total_investment.value'
            valid-scope='modal-form'
            name='disabled[total_investment]'
            :label='locales && locales.properties && locales.properties.disabled_total_investment'
            @input='countDisabledPoints'
            :precision='2'>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model='disabled.disabled_subsidy.value'
            valid-scope='modal-form'
            name='disabled[subsidy]'
            :label='locales && locales.properties && locales.properties.disabled_investment_subsidy'
            @input='countDisabledPoints'
            :precision='2'>
          </theme-numeric>
        </div>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='disabled.total'
            valid-scope='modal-form'
            name='disabled[total]'
            :label='locales && locales.properties && locales.properties.total_housing_for_disabled'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.private_outdoor_space }}
      </h2>
      <div class='mb-10'>
        <h3 class='calculate-price__form-subtitle'>
          {{ locales && locales.properties && locales.properties.private_outdoor_space }}
          <strong v-if='outdoor.space.value'>{{ outdoor.space.total || '' }}</strong>
        </h3>
        <theme-radios
          v-model='outdoor.space.value'
          name='outdoor[space]'
          :sort='true'
          sort-by='custom'
          :custom-order='outdoorSpacesCustomOrder'
          :options='outdoorSpacesOptions'
          @input='countOutdoorPoints'>
        </theme-radios>
      </div>
      <div class='mb-10'>
        <input type='hidden' name='outdoor[carport]' value='0'/>
        <theme-checkboxes
          id='carport'
          @input='countOutdoorPoints'
          label=''
          :is-single-checkbox='true'
          name='outdoor[carport]'
          v-model='outdoor.carport.value'
          :options="{ '1': `${locales && locales.properties && locales.properties.carport} ${outdoor.carport.value && outdoor.carport.total || ''}` }">
        </theme-checkboxes>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='outdoor.total'
            valid-scope='modal-form'
            name='outdoor[total]'
            :label='locales && locales.properties && locales.properties.total_outdoor'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.vop }}
        ({{
          locales &&
          locales.common &&
          locales.common.minimum + ' € ' + independantMinVopPrice
        }})
      </h2>
      <div class='grid grid-cols-1 lg:grid-cols-4 mb-10'>
        <div>
          <theme-numeric
            v-model='vop.price.value'
            valid-scope='modal-form'
            name='vop[price]'
            :label='locales && locales.properties && locales.properties.enter_vop'
            @input='countVopPoints'>
          </theme-numeric>
        </div>
      </div>
      <div class='mb-10'>
        <input
          type='hidden'
          name='vop[newly_built_renovated_house]'
          value='0'
        />
        <theme-checkboxes
          id='newly_built_renovated_house'
          @input='countVopPoints'
          label=''
          :is-single-checkbox='true'
          name='vop[newly_built_renovated_house]'
          v-model='vop.newly_built_renovated_house.value'
          :options="{ '1': locales &&locales.properties && locales.properties.newly_built_renovated_house }">
        </theme-checkboxes>
      </div>
      <div class='mb-10' v-if='vop.newly_built_renovated_house.value'>
        <h3 class='calculate-price__form-subtitle'>
          {{ locales && locales.properties && locales.properties.delivery_in }}
        </h3>
        <theme-radios
          v-model='vop.delivery.value'
          name='vop[delivery]'
          :options="{
              2015: '2015',
              2016: '2016',
              2017: '2017',
              2018: '2018',
              2019: '2019',
              2020: '2020',
              2021: '2021',
            }"
          @input='countVopPoints'>
        </theme-radios>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-4 mb-10' v-if='vop.delivery.value > 2017'>
        <div>
          <theme-autocomplete-custom
            :options='muncipalities'
            :initial='vop.location.value'
            v-model='vop.location.value'
            name='vop[location]'
            @input='countVopPoints'
            :label='locales && locales.properties && locales.properties.muncipality'>
          </theme-autocomplete-custom>
        </div>
      </div>
      <div class='grid grid-cols-2 lg:grid-cols-3 mb-10'>
        <div>
          <h3 class='calculate-price__form-subtitle'>
            {{ locales && locales.properties && locales.properties.vop_absolute }}
          </h3>
          {{ vop.absolute }}
        </div>
        <div>
          <h3 class='calculate-price__form-subtitle'>
            {{ locales && locales.properties && locales.properties.vop_surface_proportion }}
          </h3>
          {{ vop.surface_proportion }}
        </div>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='vop.total'
            valid-scope='modal-form'
            name='vop[total]'
            :label='locales && locales.properties && locales.properties.total_vop'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.renovatoin_points }}
      </h2>
      <div class='grid grid-cols-1 lg:grid-cols-4 mb-10'>
        <div>
          <theme-numeric
            v-model='renovation.price.value'
            valid-scope='modal-form'
            name='renovation[price]'
            :label='`${locales && locales.properties && locales.properties.investments_from} 1 ${investmentsDate} ${investmentsYear}`'
            @input='countRenovationPoints'>
          </theme-numeric>
        </div>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='renovation.total'
            valid-scope='modal-form'
            name='renovation[total]'
            :label='locales && locales.properties && locales.properties.total_renovation'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.care_home }}
      </h2>
      <div class='mb-10'>
        <input type='hidden' name='care_home[value]' value='0'/>
        <theme-checkboxes
          id='care_home'
          @input='countCareHomePoints'
          label=''
          :is-single-checkbox='true'
          name='care_home[value]'
          v-model='careHome.value'
          :options="{ '1': locales && locales.properties && locales.properties.care_home }">
        </theme-checkboxes>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='careHome.total'
            valid-scope='modal-form'
            name='care_home[total]'
            :label='locales && locales.properties && locales.properties.total_care_home'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.monument_allowance }}
      </h2>
      <div class='mb-10'>
        <input type='hidden' name='monument_allowance' value='0'/>
        <theme-checkboxes
          id='monumentAllowance'
          @input='countMonumentAllowancePoints'
          label=''
          :is-single-checkbox='true'
          name='monument_allowance[value]'
          v-model='monumentAllowance.value'
          :options="{ '1': locales && locales.properties && locales.properties.monument_allowance }">
        </theme-checkboxes>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='monumentAllowance.total'
            valid-scope='modal-form'
            name='monument_allowance[total]'
            :label='locales && locales.properties && locales.properties.total_monument_allowance'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-bottom'>
      <div class='default-content grid grid-cols-1 lg:grid-cols-12 items-center gap-1 lg:gap-5'>
        <div class='col-span-2 hidden lg:block'>
          <h3 class='calculate-price__form-bottom-title'>
            {{ this.locales && this.locales.common && this.locales.common.total }}
          </h3>
        </div>
        <div class='lg:col-span-7'>
          <div class='grid grid-cols-2 items-center gap-5'>
            <div class='grid lg:grid-cols-2 items-center gap-1 lg:gap-5 lg:pr-6'>
              <div class='calculate-price__form-bottom-label'>
                {{ locales && locales.properties && locales.properties.total_points }}
              </div>
              <div class='lg:hidden'>{{ totalPoints || '0' }}</div>
              <div class='hidden lg:block'>
                <theme-numeric
                  v-model='totalPoints'
                  valid-scope='modal-form'
                  name='total'
                  label=''
                  :isReadonly='true'>
                </theme-numeric>
              </div>
            </div>
            <div class='grid lg:grid-cols-2 items-center gap-1 lg:gap-5 lg:pr-6'>
              <div class='calculate-price__form-bottom-label'>
                {{ locales && locales.properties && locales.properties.max_basic_rent_price }}
              </div>
              <div class='lg:hidden'>{{ price || '0' }}</div>
              <div class='hidden lg:block'>
                <theme-numeric
                  v-model='price'
                  valid-scope='modal-form'
                  name='price'
                  label=''
                  :isReadonly='true'>
                </theme-numeric>
              </div>
            </div>
          </div>
        </div>
        <div class='lg:col-span-3 grid grid-cols-2 items-center gap-5'>
          <button type='submit' class='theme-btn theme-btn--theme'>
            {{ locales && locales.common && locales.common.download_pdf }}
          </button>
          <button type='submit' name='submit' value='save' class='theme-btn theme-btn--theme'>
            {{ locales && locales.common && locales.common.save }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import _ from 'lodash';

  export default {
    computed: {
      ...mapGetters(['metadata', 'locales']),
    },
    data() {
      return {
        total: 0,
        totalPoints: 0,
        surface: 0,
        price: 0,
        heatingTypeClone: this.heatingType,
      };
    },
    props: {
      property: {
        default: () => {
          return {};
        },
        type: Object,
      },
      energyLabelsOptions: {
        default: () => {
          return {};
        },
        type: Object,
      },
      energyLabelsCustomOrder: {
        default: () => {
          return {};
        },
        type: [Object, Array],
      },
      outdoorSpacesCustomOrder: {
        default: () => {
          return {};
        },
        type: [Object, Array],
      },
      energyLabels: {
        default: () => {
          return {};
        },
        type: Object,
      },
      energyLabelsBySlug: {
        default: () => {
          return {};
        },
        type: Object,
      },
      outdoorSpaces: {
        default: () => {
          return {};
        },
        type: Object,
      },
      outdoorSpacesOptions: {
        default: () => {
          return {};
        },
        type: Object,
      },
      independantLandlordSpendingsBase: {
        default: 0,
        type: [String, Number],
      },
      independantMinVopPrice: {
        default: 0,
        type: [String, Number],
      },
      independantVopPointPrice: {
        default: 0,
        type: [String, Number],
      },
      independantVopProportionPrice: {
        default: 0,
        type: [String, Number],
      },
      independantVopProportionPriceAmsterdamUtrecht: {
        default: 0,
        type: [String, Number],
      },
      independantMaxRentalPrices: {
        default: () => {
          return {};
        },
        type: [Array, Object],
      },
      muncipalities: {
        default: () => {
          return [];
        },
        type: Array,
      },
      heatingType: {
        default: null,
        type: [String, Number],
      },
      leaveArea: {
        default: () => {
          return {};
        },
        type: Object,
      },
      otherSpaces: {
        default: () => {
          return {};
        },
        type: Object,
      },
      heating: {
        default: () => {
          return {};
        },
        type: Object,
      },
      energy: {
        default: () => {
          return {};
        },
        type: Object,
      },
      kitchen: {
        default: () => {
          return {};
        },
        type: Object,
      },
      sanitary: {
        default: () => {
          return {};
        },
        type: Object,
      },
      disabled: {
        default: () => {
          return {};
        },
        type: Object,
      },
      outdoor: {
        default: () => {
          return {};
        },
        type: Object,
      },
      vop: {
        default: () => {
          return {};
        },
        type: Object,
      },
      renovation: {
        default: () => {
          return {};
        },
        type: Object,
      },
      careHome: {
        default: () => {
          return {};
        },
        type: Object,
      },
      monumentAllowance: {
        default: () => {
          return {};
        },
        type: Object,
      },
      facilityTypes: {
        default: () => {
          return {};
        },
        type: Object,
      },
      energyLabels: {
        default: () => {
          return {};
        },
        type: Object,
      },
      rooms: {
        default: () => {
          return [];
        },
        type: Array,
      },
      otherRooms: {
        default: () => {
          return [];
        },
        type: Array,
      },
      investmentsDate: {
        default: '',
        type: String,
      },
      investmentsYear: {
        default: '',
        type: String,
      },
      sharedParking: {
        default: () => {
          return {};
        },
        type: Object,
      },
      sharedParkingOptions: {
        default: () => {
          return {};
        },
        type: Object,
      },
      independantSettings: {
        default: () => {
          return {};
        },
        type: [Array, Object],
      },
    },
    beforeMount() {
      this.countHeatingPoints();
      this.countEnergyPoints();
      this.countKitchenPoints();
      this.countSanitaryPoints();
      this.countDisabledPoints();
      this.countOutdoorPoints();
      this.countVopPoints();
      this.countRenovationPoints();
      this.countCareHomePoints();
      this.countMonumentAllowancePoints();
    },
    methods: {
      calculateSurface(object, room, group) {
        if(object && object[room]){
          var width = parseFloat((object[room].width + "").replace(",", "."));
          if(isNaN(width)){
            width = 0;
          }
          var length = parseFloat((object[room].length + "").replace(",", "."));
          if(isNaN(length)){
            length = 0;
          }
          var surface = width * length;

          Vue.set(object[room], "surface", surface);
          switch (group) {
            case "leaveArea":
              this.countLeaveAreaPoints(object);
              break;
            case "otherSpaces":
              this.countOtherSpacesPoints(object);
              break;
          }
        }
      },
      countLeaveAreaPoints(object) {
        // Huurcommissie method: round each room to 2 decimals, sum the rounded
        // rooms, then round the COMBINED total once to whole m² before applying
        // the points-per-m² multiplier (rounding each room to a whole number
        // first, as countSurface() still does for the Energy tiers, under-counts
        // fractional rooms that individually round down).
        var sum = 0;
        for (var ob in object) {
          if (ob != "total" && ob != "include_shower") {
            var room = object[ob];
            if (room.surface) {
              sum += Math.round(parseFloat((room.surface + "").replace(",", ".")) * 100) / 100;
            }
          }
        }
        var surface = Math.round(sum);
        var total = surface * parseFloat((this.independantSettings.price_points_settings.surface_points_per_m2 + "").replace(",", ".")); //1;
        if (total >= 1 && object.include_shower == true) {
          total -= 1;
        } else if (object.include_shower == true) {
          total = 0;
        }
        Vue.set(object, "total", total);

        this.countSurface();
        this.countCareHomePoints();
        this.countTotal();
      },
      countOtherSpacesPoints(object) {
        // Same Huurcommissie combined-then-rounded-once method as countLeaveAreaPoints().
        var sum = 0;
        for (var ob in object) {
          if (ob != "total" && ob != "attic_no_staircase") {
            var room = object[ob];
            if (room.surface) {
              sum += Math.round(parseFloat((room.surface + "").replace(",", ".")) * 100) / 100;
            }
          }
        }
        var surface = Math.round(sum);
        var total = surface * parseFloat((this.independantSettings.price_points_settings.other_spaces_points_per_m2+'').replace(',', '.')); //0,75
        if (total >= 1 && object.attic_no_staircase == true) {
          total -= 5;
        } else if (object.attic_no_staircase == true) {
          total = 0;
        }
        Vue.set(object, "total", total);

        this.countSurface();
        this.countCareHomePoints();
        this.countTotal();
      },
      countSurface() {
        var sum = 0;
        for (var ob in this.leaveArea) {
          if (this.leaveArea[ob] && this.leaveArea[ob].surface) {
            sum += Math.round(
              parseFloat((this.leaveArea[ob].surface + "").replace(",", "."))
            );
          }
        }

        for (var ob in this.otherSpaces) {
          if (this.otherSpaces[ob] && this.otherSpaces[ob].surface) {
            sum += Math.round(
              parseFloat((this.otherSpaces[ob].surface + "").replace(",", "."))
            );
          }
        }
        this.surface = sum;
      },
      countHeatingPoints() {
        var sum = 0;
        var heatingPoints = 0;
        var coolingPoints = 0;
        var otherHeatingPoints = 0;
        var otherCoolingPoints = 0;
        if (this.heatingTypeClone == 1) {
          heatingPoints = parseFloat(this.heating.heated_rooms + "") * parseFloat((this.independantSettings.price_points_settings.heating.individual_boiler_points_per_room+"").replace(',', '.')); //2
          sum += heatingPoints;
          var maxOtherPoints = parseFloat((this.independantSettings.price_points_settings.heating.max_other_heating_points+'').replace(',','.'));
          var cp = parseFloat(this.heating.other_rooms_with_heating + "") * parseFloat((this.independantSettings.price_points_settings.heating.individual_boiler_points_per_other_room_with_heating+'').replace(',','.')); //2;
          if (cp < maxOtherPoints) {
            otherHeatingPoints = cp;
          } else {
            otherHeatingPoints = maxOtherPoints; //4
          }
          sum += otherHeatingPoints;
        } else if (this.heatingTypeClone == 2) {
          heatingPoints = parseFloat(this.heating.heated_rooms + "") * parseFloat((this.independantSettings.price_points_settings.heating.collective_heating_points_per_room+'').replace(',', '.')); //1.5
          sum += heatingPoints;
          var maxOtherPoints = parseFloat((this.independantSettings.price_points_settings.heating.max_other_heating_points+'').replace(',', '.'));
          var cp = parseFloat(this.heating.other_rooms_with_heating + "") * parseFloat((this.independantSettings.price_points_settings.heating.collective_heating_points_per_other_room_with_heating+'').replace(',','.')); //2;
          if (cp < maxOtherPoints) {
            otherHeatingPoints =cp;
          } else {
            otherHeatingPoints = maxOtherPoints;
          }
          sum += otherHeatingPoints;
        }
        var total = sum;
        Vue.set(this.heating, "heated_rooms_points", heatingPoints);
        Vue.set(
          this.heating,
          "other_rooms_with_heating_points",
          otherHeatingPoints
        );
        Vue.set(this.heating, "cooled_rooms_points", coolingPoints);
        Vue.set(
          this.heating,
          "other_rooms_with_cooling_points",
          otherCoolingPoints
        );
        Vue.set(this.heating, "total", total);
        this.countCareHomePoints();
        this.countTotal();
      },
      countEnergyPoints() {
        var sum = 0;
        var energyPoints = 0;
        if (this.energy.energy_performance_fee == 1) {
          if (this.energy.property_type == 1) {
            energyPoints = parseFloat((this.independantSettings.price_points_settings.energy.energy_compensation.single_family+'').replace(',', '.')); //32
          } else if (this.energy.property_type == 2) {
            energyPoints = parseFloat((this.independantSettings.price_points_settings.energy.energy_compensation.multi_family+'').replace(',', '.')); //28
          }
          sum += energyPoints;
        } else {
          if (this.energy.energy_label && this.energyLabels[this.energy.energy_label] && this.energyLabels[this.energy.energy_label]["slug"] != "no_label_or_index") {
            if (this.energy.property_type == 1) {
              energyPoints = parseFloat((this.energyLabels[this.energy.energy_label]["single_house_points"] + "").replace(',', '.'));
            } else if (this.energy.property_type == 2) {
              energyPoints = parseFloat((this.energyLabels[this.energy.energy_label]["multi_house_points"] + "").replace(',', '.'));
            }
          } else if (this.energy.energy_label && this.energyLabels[this.energy.energy_label] && this.energyLabels[this.energy.energy_label]["slug"] == "no_label_or_index" && this.energy.building_construction_year) {
            if (this.energy.building_construction_year <= 1976) {
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_g"]["single_house_points"] + ""
                ).replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_g"]["multi_house_points"] + ""
                ).replace(',', '.'));
              }
            } else if (this.energy.building_construction_year <= 1978) {
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_f"]["single_house_points"] + ""
                ).replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_f"]["multi_house_points"] + ""
                ).replace(',', '.'));
              }
            } else if (this.energy.building_construction_year <= 1983) {
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_e"]["single_house_points"] + ""
                ).replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_e"]["multi_house_points"] + ""
                ).replace(',', '.'));
              }
            } else if (this.energy.building_construction_year <= 1991) {
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_d"]["single_house_points"] + ""
                ).replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_d"]["multi_house_points"] + ""
                ).replace(',', '.'));
              }
            } else if (this.energy.building_construction_year <= 1997) {
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_c"]["single_house_points"] + ""
                ).replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_d"]["multi_house_points"] + ""
                ).replace(',', '.'));
              }
            } else if (this.energy.building_construction_year <= 1999) {
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_c"]["single_house_points"] + ""
                ).replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_c"]["multi_house_points"] + ""
                ).replace(',', '.'));
              }
            } else if (this.energy.building_construction_year <= 2001) {
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_b"]["single_house_points"] + ""
                ).replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_b"]["multi_house_points"] + ""
                ).replace(',', '.'));
              }
            } else if (this.energy.building_construction_year > 2001) {
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_a"]["single_house_points"] + ""
                ).replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_a"]["multi_house_points"] + ""
                ).replace(',', '.'));
              }
            }
          }          
          sum += energyPoints;
        }
        var total = sum;
        Vue.set(this.energy, "energy_points", total);
        Vue.set(this.energy, "total", total);
        this.countCareHomePoints();
        this.countTotal();
      },
      countKitchenPoints() {
        var sum = 0;
        var maxPoints = 0;
        var addPoints = 0;
        if (this.kitchen.worktop_length.value == 2) {
          addPoints = parseFloat((this.independantSettings.price_points_settings.kitchen.worktop_1_2m_points + "").replace(",", ".")); //4
          maxPoints = parseFloat((this.independantSettings.price_points_settings.kitchen.worktop_1_2m_max_points + "").replace(",", ".")); //8
          
        } else if (this.kitchen.worktop_length.value == 3) {
          addPoints = parseFloat((this.independantSettings.price_points_settings.kitchen.worktop_2m_points + "").replace(",", ".")); //7
          maxPoints = parseFloat((this.independantSettings.price_points_settings.kitchen.worktop_2m_max_points + "").replace(",", ".")); //14
        }
        Vue.set(this.kitchen.worktop_length, "points", addPoints);
        Vue.set(this.kitchen.worktop_length, "total", addPoints);
        sum += addPoints;

        for (var ob in this.kitchen) {
          var element = this.kitchen[ob];
          var points = 0;
          if (ob == "extra_wall_tiling" || ob == "floor_tiles") {
            points = parseFloat((element.points + "").replace(",", ".")) * Math.floor(parseFloat((element.value + "").replace(",", ".")) / 2);
            Vue.set(this.kitchen[ob], "total", points);
          } else if (ob == "overall_luxury_version") {
            points = parseFloat((element.value+ "").replace(",", ".")) <= 2 ? parseFloat((element.value + "").replace(",", ".")) : 2;
            Vue.set(this.kitchen[ob], "total", points);
          } else if (ob == "cooker") {
            if (element.value == 1) {
              points = parseFloat((this.independantSettings.price_points_settings.kitchen.gas_cooker_points + "").replace(",", ".")); //0.5
            } else if (element.value == 2) {
              points = parseFloat((this.independantSettings.price_points_settings.kitchen.ceramic_cooker_points + "").replace(",", ".")); //1
            } else if (element.value == 3) {
              points = parseFloat((this.independantSettings.price_points_settings.kitchen.induction_cooker_points + "").replace(",", ".")); //1.25
            }
            Vue.set(this.kitchen[ob], "total", points);
          } else if (ob == "oven") {
            if (element.value == 1) {
              points = parseFloat((this.independantSettings.price_points_settings.kitchen.gas_oven_points + "").replace(",", ".")); //0.75
            } else if (element.value == 2) {
              points = parseFloat((this.independantSettings.price_points_settings.kitchen.electric_oven_points + "").replace(",", ".")); //1.25
            }
            Vue.set(this.kitchen[ob], "total", points);
          } else if (ob != "total" && ob != "worktop_length") {
            points = parseFloat((element.points + "").replace(",", ".")) * Math.round(parseFloat((element.value + "").replace(",", ".")));
            Vue.set(this.kitchen[ob], "total", points);
          }
          if (sum + points <= maxPoints) {
            sum += points;
          } else {
            sum = maxPoints;
          }
        }
        var total = sum;
        Vue.set(this.kitchen, "total", total);
        this.countCareHomePoints();
        this.countTotal();
      },
      countSanitaryPoints() {
        var sum = 0;
        var maxPoints = 0;
        var addPoints = 0;
      
        if (this.sanitary.shower_bath.value == 1) {
          addPoints = parseFloat((this.independantSettings.price_points_settings.sanitary.shower_points +'').replace(',', '.')); //4
          maxPoints = parseFloat((this.independantSettings.price_points_settings.sanitary.shower_max_points +'').replace(',', '.')); //8
        } else if (this.sanitary.shower_bath.value == 2) {
          addPoints = parseFloat((this.independantSettings.price_points_settings.sanitary.bath_points +'').replace(',', '.')); //6
          maxPoints = parseFloat((this.independantSettings.price_points_settings.sanitary.bath_max_points +'').replace(',', '.')); //12
        } else if (this.sanitary.shower_bath.value == 3) {
          addPoints = parseFloat((this.independantSettings.price_points_settings.sanitary.shower_bath_points +'').replace(',', '.')); //7
          maxPoints = parseFloat((this.independantSettings.price_points_settings.sanitary.shower_bath_max_points +'').replace(',', '.')); //14
        }
        Vue.set(this.sanitary.shower_bath, "points", addPoints);
        Vue.set(this.sanitary.shower_bath, "total", addPoints);
        sum += addPoints;

        if (this.sanitary.number_of_toilets.value) {
          var p = parseFloat((this.sanitary.number_of_toilets.points+'').replace(',', '.')) * Math.round(parseFloat((this.sanitary.number_of_toilets.value + "").replace(",", ".")));
          maxPoints += p;
          sum += p;
          Vue.set(this.sanitary.number_of_toilets, "total", p);
        }
        if (this.sanitary.number_of_washbasins.value) {
          var p = parseFloat((this.sanitary.number_of_washbasins.points+'').replace(',', '.')) * Math.round(parseFloat((this.sanitary.number_of_washbasins.value + "").replace(",", ".")));
          maxPoints += p;
          sum += p;
          Vue.set(this.sanitary.number_of_washbasins, "total", p);
        }
        for (var ob in this.sanitary) {
          var element = this.sanitary[ob];
          var points = 0;
          if (ob == "extra_wall_tiling") {
            points = parseFloat((element.points+'').replace(',', '.')) * Math.floor(parseFloat((element.value + "").replace(",", ".")) / 2);
            Vue.set(this.sanitary[ob], "total", points);
          } else if (ob == "overall_luxury_version") {
            points = element.value <= 2 ? element.value : 2;
            Vue.set(this.sanitary[ob], "total", points);          
          } else if (
            ob != "total" &&
            ob != "number_of_toilets" &&
            ob != "number_of_separate_toilets" &&
            ob != "number_of_washbasins" &&
            ob != "number_of_power_outlet" &&
            ob != "shower_bath"
          ) {
            if(element.old == 1){
              points = parseFloat((element.points+'').replace(',', '.')) * Math.round(parseFloat((element.value + "").replace(",", ".")));
              Vue.set(this.sanitary[ob], "total", points);
            }
          }
          if (sum + points <= maxPoints) {
            sum += points;
          } else {
            sum = maxPoints;
          }
        }
        var total = sum;
        Vue.set(this.sanitary, "total", total);
        this.countCareHomePoints();
        this.countTotal();
      },
      countDisabledPoints() {
        var sum = 0;
        var maxPoints = 0;
        if (this.disabled.total_investment.value && parseFloat((this.disabled.total_investment.value + "").replace(",", ".") - parseFloat((this.disabled.disabled_subsidy.value + "").replace(",", ".")) > 0)) {
          var p = parseFloat((this.disabled.total_investment.points + "").replace(",", ".")) * Math.floor(parseFloat(((this.disabled.total_investment.value + "").replace(",", ".") - parseFloat((this.disabled.disabled_subsidy.value + "").replace(",", "."))) / this.independantLandlordSpendingsBase));
          sum += p;
          Vue.set(this.disabled.total_investment, "total", p);
        }
        var total = sum;
        Vue.set(this.disabled, "total", total);

        this.countCareHomePoints();
        this.countTotal();
      },
      countOutdoorPoints() {
        var sum = 0;
        if (this.outdoor.space.value && this.outdoorSpaces[this.outdoor.space.value]) {
          var points = parseFloat((this.outdoorSpaces[this.outdoor.space.value]["points"] + "").replace(",", "."));
          Vue.set(this.outdoor.space, "points", points);
          Vue.set(this.outdoor.space, "total", points);
          sum += points;
        }
        if (this.outdoor.carport.value && this.outdoor.carport.value == 1) {
          var p = parseFloat((this.outdoor.carport.points + "").replace(",", "."));
          Vue.set(this.outdoor.carport, "total", p);
          sum += p;
        }
        
        var total = sum;
        Vue.set(this.outdoor, "total", total);

        this.countCareHomePoints();
        this.countTotal();
      },
      countVopPoints() {
        var sum = 0;
        var price = this.vop.price.value;
        if (price > 0 && price < parseFloat(this.independantMinVopPrice)) {
          price = this.independantMinVopPrice;
        }

        var pointsPerSurface = 0;
        var absolute = 0;
        if (price) {
          absolute = (parseFloat(price) / parseFloat(this.independantVopPointPrice)).toFixed(2);
          if (
            this.vop.location.value &&
            this.muncipalities.includes(this.vop.location.value) &&
            this.surface < 40 &&
            this.surface > 0
          ) {
            pointsPerSurface = ((parseFloat(price) / parseFloat((this.surface+'').replace(',', '.'))) / parseFloat(this.independantVopProportionPriceAmsterdamUtrecht)).toFixed(2);
          } else if (this.surface > 0) {
            pointsPerSurface = ((parseFloat(price) / parseFloat((this.surface+'').replace(',', '.'))) / parseFloat(this.independantVopProportionPrice+'')).toFixed(2);
          }
        }
        

        var total = parseFloat(absolute) + parseFloat(pointsPerSurface);
        Vue.set(this.vop, "total", total);
        this.countCareHomePoints();
        var total = Math.round(total);
        Vue.set(this.vop, "absolute", absolute);
        Vue.set(this.vop, "surface_proportion", pointsPerSurface);
        Vue.set(this.vop, "total", total);

        this.countTotal();
      },
      countRenovationPoints() {
        var sum = 0;
        var price = this.renovation.price.value;

        var total = 0;
        if (price >= 10000) {
          total = (price / 1000) * parseFloat((this.independantSettings.price_points_settings.renovation.price_points+'').replace(',', '.'));//0.2
        }
        Vue.set(this.renovation, "total", total);

        this.countCareHomePoints();
        this.countTotal();
      },
      countSharedParkingPoints() {
        var points = 0;
        if(parseFloat((this.sharedParking.number_of_addresses+'').replace(",", ".")) > 0){
          points = parseFloat((this.independantSettings.price_points_settings.shared_parking[this.sharedParking.type]+'').replace(',', '.')) / parseFloat((this.sharedParking.number_of_addresses+'').replace(",", "."));
        }
        Vue.set(this.sharedParking, "total", points);
        this.countTotal();
      },
      countCareHomePoints() {
        var sum = 0;
        var total = 0;
        if (this.careHome.value && this.careHome.value == 1) {
          total =
            this.leaveArea.total +
            this.otherSpaces.total +
            this.sharedParking.total +
            this.heating.total +
            this.energy.total +
            this.kitchen.total +
            this.sanitary.total +
            this.disabled.total +
            this.outdoor.total +
            this.vop.total +
            this.renovation.total;
          total = total * (parseFloat((this.careHome.points+'').replace(",", "."))/100);
        }
        if (this.careHome.has_automatic_bell && this.careHome.has_automatic_bell == 1) {
          total += parseFloat((this.careHome.automatic_bell_points).replace(",", "."));
        }
        Vue.set(this.careHome, "total", total);
        this.countTotal();
      },
      countMonumentAllowancePoints() {
        var sum = 0;
        var total = 0;
        if (this.monumentAllowance.value && this.monumentAllowance.value == 1) {
          total = 50;
        }
        Vue.set(this.monumentAllowance, "total", total);
        this.countTotal();
      },
      countTotal() {
        var total =
          this.leaveArea.total +
          this.otherSpaces.total +
          this.heating.total +
          this.energy.total +
          this.kitchen.total +
          this.sanitary.total +
          this.disabled.total +
          this.outdoor.total +
          this.sharedParking.total +
          this.vop.total +
          parseFloat((this.renovation.total+'').replace(",", ".")) +
          this.careHome.total +
          this.monumentAllowance.total;
        this.total = Math.round(total);
        this.totalPoints =
          this.total && parseFloat(this.total + "") > 40 ? this.total : 40;
        this.price = this.lookupRentByPoints(this.totalPoints);
      },
      lookupRentByPoints(points) {
        var prices = this.independantMaxRentalPrices;
        var p = Math.max(40, Math.round(parseFloat(points) || 40));
        if (p <= 250) {
          return parseFloat((prices[p] + '').replace(',', '.')) || 0;
        }
        var price250 = parseFloat((prices[250] + '').replace(',', '.')) || 0;
        var price249 = parseFloat((prices[249] + '').replace(',', '.')) || 0;
        if (price250 > 0 && price249 > 0) {
          var marginalRate = price250 - price249;
          return Math.round((price250 + (p - 250) * marginalRate) * 100) / 100;
        }
        return price250;
      },
    },
  };
</script>
